import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { switchMap, tap } from 'rxjs';
import { IserverService } from '../services/iserver.service';
import { ObjectTypeService } from '../services/object-type.service';
import { Gen_ObjectType } from '../types/generated-objectType.type';

interface IServerObjectTypeStateModel {
  loading: boolean;
  objectTypes: Gen_ObjectType[];
}
export class LoadObjectTypes {
  static readonly type = '[IserverObjectTypes] Load ObjectTypes';
}
@Injectable()
@State<IServerObjectTypeStateModel>({
  name: 'iserverobjecttype',
  defaults: {
    loading: false,
    objectTypes: []
  },
})
export class IServerObjectTypeState {

  constructor(private objectTypeService: ObjectTypeService) {

  }
  @Action(LoadObjectTypes)
  loadObjectTypes(ctx: StateContext<IServerObjectTypeStateModel>) {
    ctx.patchState({ loading: true });
    return this.objectTypeService.getObjectTypes().pipe(tap(objectTypes => {
      ctx.patchState({ objectTypes, loading: false })
    }));
  }

  @Selector()
  static loading(state: IServerObjectTypeStateModel): boolean {
    return state.loading;
  }

  @Selector()
  static objectTypes(state: IServerObjectTypeStateModel): Gen_ObjectType[] {
    return state.objectTypes;
  }

}
